export default __webpack_public_path__ + "static/media/flag-lesotho.a7556a0f.svg";